import { render, staticRenderFns } from "./SDInfo.vue?vue&type=template&id=65691d8f&scoped=true"
import script from "./SDInfo.vue?vue&type=script&lang=js"
export * from "./SDInfo.vue?vue&type=script&lang=js"
import style0 from "./SDInfo.vue?vue&type=style&index=0&id=65691d8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65691d8f",
  null
  
)

export default component.exports